import React from 'react';
import { Check } from 'lucide-react';
const comparisonData = [{
  sit: 'Querés hacer pan con textura real',
  mega: 'Tenés recetas base',
  jean: 'Técnica profesional de alveolado, corteza y fermentación'
}, {
  sit: 'Querés aprender masa madre sin gluten',
  mega: 'No tenés el método completo',
  jean: 'Guía paso a paso de masa madre desde cero'
}, {
  sit: 'Querés resultados de panadería profesional',
  mega: 'Cocinás bien para casa',
  jean: 'Panettone, baguette y hojaldre de nivel profesional'
}, {
  sit: 'Querés mejorar digestión y liviandad',
  mega: 'Solo seguís recetas',
  jean: 'Técnicas de fermentación larga y recuperación intestinal'
}];
const includes = ['Técnica pro de alveolado y corteza real', 'Guía completa de masa madre sin gluten desde cero', 'Técnicas de fermentación larga para panes más livianos y sanos', 'Protocolo de recuperación intestinal — 50 páginas', 'Recetas elite de panadería: Panettone, Baguette y hojaldre', 'Método profesional para lograr textura, corteza y miga real sin trigo'];
export function ComparisonTable() {
  return <section className="py-16 px-4 bg-brand-ink border-t border-brand-gold/15 relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-45"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-46">
        <div className="mb-10 text-center" data-id="element-47">
          <h2 className="font-display text-2xl sm:text-4xl font-extrabold text-brand-gold flex items-center justify-center gap-3 tracking-tight" data-id="element-48">
            <span data-id="element-49">👑</span> ¿QUÉ AGREGA LA MASTERCLASS PAN DE CAMPO Y MASA
            MADRE™?
          </h2>
        </div>

        <div className="rounded-2xl overflow-hidden mb-12 border border-brand-gold/30 bg-brand-base/70 backdrop-blur-sm" data-id="element-50">
          <div className="overflow-x-auto" data-id="element-51">
            <table className="w-full text-left border-collapse" data-id="element-52">
              <thead data-id="element-53">
                <tr className="bg-brand-gold/15 text-brand-gold border-b border-brand-gold/30" data-id="element-54">
                  <th className="p-4 font-extrabold w-1/3 text-center tracking-wide uppercase text-xs sm:text-sm" data-id="element-55">
                    Situación
                  </th>
                  <th className="p-4 font-extrabold w-1/3 text-center border-l border-brand-gold/20 tracking-wide uppercase text-xs sm:text-sm" data-id="element-56">
                    ❌ Solo Megapack
                  </th>
                  <th className="p-4 font-extrabold w-1/3 text-center border-l border-brand-gold/20 tracking-wide uppercase text-xs sm:text-sm" data-id="element-57">
                    ✅ Con Masterclass
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-58">
                {comparisonData.map((row, i) => <tr key={i} className="border-b border-brand-gold/15 last:border-b-0" data-id="element-59">
                    <td className="p-4 text-sm font-medium text-brand-cream/85 text-center" data-id="element-60">
                      {row.sit}
                    </td>
                    <td className="p-4 text-sm text-center text-brand-cream/55 border-l border-brand-gold/15 italic" data-id="element-61">
                      {row.mega}
                    </td>
                    <td className="p-4 text-sm font-bold text-brand-gold text-center border-l border-brand-gold/15" data-id="element-62">
                      {row.jean}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div className="bg-brand-base/70 backdrop-blur-sm rounded-2xl p-8 border border-brand-gold/30" data-id="element-63">
          <h3 className="text-lg sm:text-xl font-extrabold text-brand-gold mb-6 flex items-center justify-center gap-2 tracking-wide text-center" data-id="element-64">
            LA MASTERCLASS INCLUYE
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 mb-8" data-id="element-65">
            {includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-left" data-id="element-66">
                <Check size={16} className="text-brand-gold shrink-0 mt-1" strokeWidth={3} data-id="element-67" />
                <span className="text-sm text-brand-cream/90 font-medium leading-relaxed" data-id="element-68">
                  {item}
                </span>
              </li>)}
          </ul>
          <div className="text-center pt-6 border-t border-brand-gold/20" data-id="element-69">
            <p className="text-brand-cream/40 line-through text-base mb-1" data-id="element-70">
              $69.000
            </p>
            <p className="font-display text-3xl sm:text-4xl font-extrabold text-brand-gold mb-5" data-id="element-71">
              $27.990 ARS
            </p>
            <a href="https://www.impulsodigitalstore.com/cart/43016137965645:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-brand-gold text-brand-base font-bold text-base sm:text-lg py-4 px-8 rounded-xl hover:bg-[#C29A35] transition-colors uppercase tracking-wide" data-id="element-72">
              👑 QUIERO EL PACK COMPLETO
            </a>
          </div>
        </div>
      </div>
    </section>;
}